import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { spacing } from "@mui/system";

import { Avatar, Paper, Typography, Box } from "@mui/material";

import { ReactComponent as Logo } from "../../vendor/logo.svg";
import SignInComponent from "../../components/auth/SignIn";

const Spacer = styled.div(spacing);

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 64px;
  height: 64px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function SignIn() {
  return (
    <React.Fragment>
      <Box>
        <img
          style={{ height: "35px" }}
          src="https://hzero.com.br/images/logotipo/logotipo-hzero.png"
        />
      </Box>
      <Spacer mb={6} />
      <Wrapper>
        <Helmet title="Sign In" />
        <SignInComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default SignIn;
